


























import { Component, Vue, Inject } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import SingleApproval from "./approval/single-approval.vue";
import EditApproval from "./approval/edit-approval.vue"
import PageRequest from "@/store/entities/page-request";
class PageApprovalRequest extends PageRequest {
  keyword: string = "";
  officeId: number = null;
  approveState: number = null;
}

@Component({ components: { SingleApproval, EditApproval } })
export default class Approval extends AbpBase {
  singleApprovalModal: boolean = false;
  editApprovalModal: boolean = false;
  pagerequest: PageApprovalRequest = new PageApprovalRequest();

  get list() {
    return this.$store.state.approval.list;
  }
  get pageSize() {
    return this.$store.state.approval.pageSize;
  }
  get totalCount() {
    return this.$store.state.approval.totalCount;
  }
  get currentPage() {
    return this.$store.state.approval.currentPage;
  }

  pageChange(page: number) {
    this.$store.commit("approval/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("approval/setPageSize", pagesize);
    this.getpage();
  }
  approval(item){
    (this.$refs.singleApproval as any).init(item);
    this.singleApprovalModal = true;
  }
  edit(){
    this.editApprovalModal = true;
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    await this.$store.dispatch({
      type: "approval/getAll",
      data: this.pagerequest,
    });
  }
  async created() {
    this.getpage();
  }
  columns = [
    {
      title: this.L("MeetingTopic"),
      key: "topic",
    },
    {
      title: this.L("Date"),
      key:"appointmentDate"
    },
    {
      title: this.L("AppointmentTime"),
      key: "appointmentTime",
    },
    {
      title: this.L("MeetingOffice"),
      key: "meetingRoom",
    },
    {
      title: this.L("Applicant"),
      key: "appointmentMan",
    },
    {
      title: this.L("Remark"),
      key: "remark",
    },
    {
      title: this.L("State"),
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.approveState == 0
            ? this.L("WAIT")
            : params.row.approveState == 1
            ? this.L("PASS")
            : this.L("FAIL")
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 250,
      align: 'center',
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "info",
                size: "small"
              },
              style: {
                marginRight: "5px",
                display:(params.row.approveState != 0)?"none":"inline-block"
              },
              on: {
                click: () => {
                  this.$store.commit('approval/edit',params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small"
              },
              style: {
                marginRight: "5px",
                display:(params.row.approveState != 0)? "none": "inline-block"
              },
              on: {
                click: () => {
                  this.approval(params.row);
                },
              },
            },
            this.L("MeetingApproval")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {},
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
}
